import defaultTemplate from './template/defaultTemplate.twig';
import Slider from 'components/slider';
import Utils from 'common/scripts/utils';

const locationWrap = document.querySelector('.j-slider-location');
const sliderOptions = {
    slider      : locationWrap,
    dots        : false,
    thumbnails  : false,
    arrow       : false,
    counter     : false,
    destroy     : true,
    modify      : 'bg_transparent',
    slideVisible: 1.35
};


if (Utils.getWindowWidth() < 670) {
    if (locationWrap) {
        const locationSlider = new Slider();

        locationSlider.init(sliderOptions);
    }
}

window.addEventListener('resize', () => {
    if (locationWrap) {
        if (Utils.getWindowWidth() < 670) {
            const sliderReady = locationWrap.querySelector('.slider__slides');

            if (!sliderReady) {
                const locationSlider = new Slider();

                locationSlider.init(sliderOptions);
            }
        } else {
            const sliderReady = locationWrap.querySelector('.slider__slides');

            if (sliderReady) {
                const elements = Array.from(locationWrap.querySelectorAll('.location__cards-item'));
                const stringElements = elements.map((element) => {
                    return element.outerHTML;
                });
                const defaultHtml = defaultTemplate({items: stringElements});

                locationWrap.style = '';

                Utils.clearHtml(locationWrap);

                Utils.insetContent(locationWrap, defaultHtml);
            }
        }
    }
});
